import { colors } from '../../colors';
var gallery = {
  bgColor: colors.paleGrey,
  textBg: colors.white,
  textColor: colors.brightRed,
  modalBgColor: colors.white,
  closeIconColor: colors.black,
  modalHeadingColor: colors.black,
  modalCaptionColor: colors.brightRed,
  modalParaColor: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default gallery;